module.exports = __webpack_public_path__ + "img/img_one_map_retail@3x.6ff14f39.png";